import React, { useState } from 'react';
import ResponseFile from './ResponseFile';
import FileCopyModal from '../linked-submissions/FileCopyModal';

const FileValue = ({
  field,
  response,
  isEditing,
  adminField,
  isUploading,
  handleUpdateFilename,
  handleDestroyFile,
  handleAddFile,
  handleFileCopy,
  group,
}) => {
  const [showCopyFileModal, setShowCopyFileModal] = useState(false);
  const htmlForm = () => $('.submission ' + '#addNewFile_' + field.id)[0];

  return (
    <div className={'input-group full'}>
      {isUploading ? (
        <>
          <label>{field.name}:</label>
          <div className='spinner-container'>
            <i
              className='fa-solid fa-arrows-rotate fa-spin big-spinner'
              title='spinner'
            ></i>
          </div>
        </>
      ) : isEditing || adminField ? (
        <>
          <div className='file-field-title'>
            <label>{field.name}:</label>
            <form
              encType='multipart/form-data'
              action={`/manage/responses/${response.id}/add_file`}
              method='post'
              id={`addNewFile_${field.id}`}
            >
              {group && (
                <>
                  <label
                    className='add-file-field'
                    title='Copy File from Linked Submission'
                    onClick={(e) => setShowCopyFileModal(true)}
                  >
                    <i className='fa-solid fa-copy'></i>
                  </label>
                  <FileCopyModal
                    showCopyFileModal={showCopyFileModal}
                    toggleCopyFileModal={() =>
                      setShowCopyFileModal(!showCopyFileModal)
                    }
                    groupFormsSubsResponses={group.group_forms}
                    field={field}
                    responseID={response?.id}
                    handleFileCopy={handleFileCopy}
                  />
                </>
              )}

              <label
                className='add-file-field'
                data-id={response ? response.id : 'new'}
                title='Add New File'
              >
                <i className='fa-solid fa-upload' aria-hidden='true'></i>
                <input
                  type='file'
                  name='response[value]'
                  onChange={() => handleAddFile(htmlForm())}
                />
              </label>
            </form>
          </div>

          {response &&
            response.response_files.map((rf) => {
              return (
                <ResponseFile
                  key={rf.id}
                  placeholder={field.placeholder}
                  responseFile={rf}
                  handleDestroyFile={handleDestroyFile}
                  handleUpdateFilename={handleUpdateFilename}
                />
              );
            })}
        </>
      ) : (
        <>
          <label>{field.name}:</label>
          <ul className='manage-file-list-display'>
            {response &&
              response.response_files.map((rf) => {
                return (
                  <li key={rf.id}>
                    <a target='_blank' href={`/manage/response_files/${rf.id}`}>
                      {rf.filename}
                    </a>
                  </li>
                );
              })}
          </ul>
        </>
      )}
    </div>
  );
};

export default FileValue;
